// PickDetailFixtures.js

import { useEffect, useState } from "react";
import { utcToLocalTime, utcToLocalDate } from "../../../utils/convertTime";
import arrowBack from "../../Asserts/images/arrow_back.svg";
import PickFixtureConfirmPopup from "../../popups/PickFixtureConfirmPopup";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { updatePickMAtchWeek } from "../RoundToJoin/roundToJoin.slice";
import useDeviceType from "../../Utiles/FindDevice";
import PitchImage from "../../Asserts/images/pitch_img.svg";
import GlassSlider from "../../Components/Slider";
import DifficultyRating from "./DifficultyRating";
import { baseURL } from "../../services/axiosConfig";
import { refreshTokenV2 } from "../../services/api";
import useWebSocket from "../../websoket/websocket";
import toast, { Toaster } from "react-hot-toast";
import useToastMessage from "../../Utiles/Toaster";

const CircularLoader = () => (
  <div className="flex flex-col items-center justify-center py-8">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
    <div className="text-blue-500 font-medium">Data fetching...</div>
  </div>
);

const isCheckStatusLive = status => !['FT', 'AET', 'PEN', 'NS'].includes(status);

const COLOR_RATING = [
  {
    id: 1,
    colorCode: '#2C5626',
    textColor: "#FFFFFF",
    lable: 1
  },
  {
    id: 2,
    colorCode: '#00FF86',
    textColor: "#000000",
    lable: 2
  },
  {
    id: 3,
    colorCode: '#E7E7E7',
    textColor: "#000000",
    lable: 3
  },
  {
    id: 4,
    colorCode: '#F1003A',
    textColor: "#FFFFFF",
    lable: 4
  },
  {
    id: 5,
    colorCode: '#8F0025',
    textColor: "#FFFFFF",
    lable: 5
  },
]

// Reusable TeamBlock
const TeamBlock = ({
  teamType,
  short,
  logo,
  teamId,
  currentFixtureId,
  selectedPickTeam,
  onClick,
  componentType,
  currentMatchWeek,
  pickDetailMatchWeek,
  pickStatus,
  setFisttime,
  isTimeEnd,
  allOtherPlayerData,
  status
}) => {

  const teamInfo = short?.find((ele) => ele.team_type === teamType);
  const code = teamInfo?.code?.slice(0, 3)?.toUpperCase() ?? "";
  const notAvailable = teamInfo?.not_available;

  const isSelected =
    selectedPickTeam?.teamId === currentFixtureId &&
    selectedPickTeam?.teamType === teamType;

  const isHome = teamType === "home";
  const isClickable = componentType === "choose pick" && !notAvailable;

  return (
    <div
      className={`flex items-center gap-2 border transition-all duration-150 relative
    ${!isTimeEnd &&
          isClickable &&
          pickDetailMatchWeek == currentMatchWeek &&
          pickStatus !== "Lost" &&
          pickStatus !== "JackPot"
          ? "cursor-pointer hover:border-blue-500 hover:bg-[#0000001A]"
          : ""
        }
    ${isSelected ? "border-2 border-blue-500 bg-blue-100" : "border-transparent"}
    ${notAvailable ? "opacity-50 pointer-events-none" : ""}
    rounded-[5px] p-[2%] `}
      onClick={() => {
        if (
          !isTimeEnd &&
          isClickable &&
          pickDetailMatchWeek == currentMatchWeek &&
          pickStatus !== "Lost" &&
          pickStatus !== "JackPot"
        ) {
          setFisttime(false);
          onClick(currentFixtureId, teamType);
        }
      }}
      tabIndex={isClickable ? 0 : -1}
    >
      <div
        className={`absolute w-[19px] h-[19px] top-1/2 -translate-y-1/2 ${isHome ? "left-[-9px]" : "right-[-9px]"
          }`}
        style={{ visibility: isSelected ? "visible" : "hidden" }}
      ></div>
      {isHome ? (
        <>
          <span className={`w-[3ch] text-center text-[13px] font-mono font-semibold text-[#00000080] ${window.innerWidth >= 820 && window.innerWidth <= 1180 ? " ml-0" : "ml-2 sm:ml-4"}`}>
            {code.padEnd(3, " ")}
          </span>
          <img
            src={logo}
            alt={`${teamType}-logo`}
            className="h-7 md:h-9 md:w-9 w-7 object-contain mx-1"
          />
        </>
      ) : (
        <>
          <img
            src={logo}
            alt={`${teamType}-logo`}
            className="h-7 w-7 md:h-9 md:w-9 object-contain mx-1"
          />
          <span className="w-[3ch] text-center text-[13px] font-mono font-semibold text-[#00000080] mr-2 sm:mr-4">
            {code.padEnd(3, " ")}
          </span>
        </>
      )}

    </div>
  );
};

const TeamSection = ({
  short,
  start,
  hometeam_logo,
  awayteam_logo,
  index,
  fixtureLeangth,
  id,
  selectedPickTeam,
  handleClickTeamSide,
  componentType,
  pickDetailMatchWeek,
  pickStatus,
  currentMatchWeek,
  setFisttime,
  isTimeEnd,
  result,
  status,
  awayteamGoal,
  hometeamGoal,
}) => {
  const deviceType = useDeviceType();
  return (
    <div
      className={`w-full flex flex-row items-center justify-between gap-0 px-0 py-[5px] sm:py-2 mt-1
      ${index !== fixtureLeangth - 1 ? "border-b border-[#37003C22] pb-1" : ""}
      md:gap-2`}
      style={{ minHeight: 63 }}
    >
      <TeamBlock
        teamType="home"
        short={short}
        logo={hometeam_logo}
        teamId={id}
        currentFixtureId={id}
        selectedPickTeam={selectedPickTeam}
        onClick={handleClickTeamSide}
        componentType={componentType}
        currentMatchWeek={currentMatchWeek}
        pickStatus={pickStatus}
        pickDetailMatchWeek={pickDetailMatchWeek}
        setFisttime={setFisttime}
        isTimeEnd={isTimeEnd}
        status={status}
      />
      {deviceType === "mobile" ? (<>
        {status.toUpperCase() === 'NS' ?
          <div className="mx-1 flex flex-col items-center min-w-[70px]">
            <span
              className="border border-[#ddd] text-[#37003C99] rounded-md bg-[#F5F2F580] font-medium 
                      text-[13px] px-3 py-1 leading-tight tracking-tight flex flex-col md:flex-row md:items-center"
            >
              <span>
                {utcToLocalDate(start)}
                <span className="hidden md:inline"> | </span>
              </span>
              <span className="md:ml-1 text-center">{utcToLocalTime(start)}</span>
            </span>
          </div> :
          <div
            className="mx-1 flex gap-2 items-center min-w-[70px] border border-[#ddd] text-[#37003C99] rounded-md bg-[#F5F2F580] font-medium 
                      text-[13px] px-3 py-1 leading-tight tracking-tight"
          >
            <span>{hometeamGoal}</span>
            {
              isCheckStatusLive(status) ? <span
                style={{
                  display: "inline-block",
                  margin: "0 6px",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#37c570",
                  verticalAlign: "middle",
                  boxShadow: "0 0 6px 2px rgba(0, 128, 0, 0.6)",
                }}
              ></span>
                : ":"
            }
            <span>{awayteamGoal}</span>

          </div>}
      </>) : (
        <>
          {status.toUpperCase() === 'NS' ? (

            <div className={`mx-1 flex flex-col items-center ${window.innerWidth >= 820 && window.innerWidth <= 1180 ? "min-w-[140px]" : "min-w-[70px]"}`}>
              <span
                className={`border border-[#ddd] text-[#37003C99] rounded-md bg-[#F5F2F580] font-medium 
             ${window.innerWidth >= 820 && window.innerWidth <= 1180 ? "text-[11px] px-2 py-1 flex flex-row items-center gap-1" : `text-[13px] ${window.innerWidth < 1250 ? "px-1 py-3" : "px-1 py-3"} gap-1 lg:flex-row flex-col`} leading-tight tracking-tight`}
              >
                <span className={`${window.innerWidth >= 820 && window.innerWidth <= 1180 ? "text-[11px]" : window.innerWidth < 1250 ? "text-[12px]" : "text-[14px]"} whitespace-nowrap`}>{utcToLocalDate(start)}</span>
                <span className={`${window.innerWidth >= 820 && window.innerWidth <= 1180 ? "inline" : "hidden lg:inline"}`}>{" "}|{" "}</span>
                <span className={`${window.innerWidth >= 820 && window.innerWidth <= 1180 ? "text-[11px]" : window.innerWidth < 1250 ? "text-[12px]" : "text-[14px]"} whitespace-nowrap`}>{utcToLocalTime(start)}</span>
              </span>

            </div>
          ) : (
            <>


              {
                status.toUpperCase() === 'FT' ?
                  <div
                    className="mx-1 flex gap-2 items-center min-w-[70px] border border-[#ddd] text-[#37003C99] rounded-md bg-[#F5F2F580] font-medium 
                      text-[13px] px-3 py-1 leading-tight tracking-tight"
                  >
                    <span>{hometeamGoal}</span>
                    {
                      isCheckStatusLive(status) ? <span
                        style={{
                          display: "inline-block",
                          margin: "0 6px",
                          width: "10px",
                          height: "10px",
                          borderRadius: "50%",
                          backgroundColor: "#37c570",
                          verticalAlign: "middle",
                          boxShadow: "0 0 6px 2px rgba(0, 128, 0, 0.6)",
                        }}
                      ></span>
                        : ":"
                    }
                    <span>{awayteamGoal}</span>

                  </div> :
                  <div
                    className="mx-1 flex gap-2 items-center min-w-[70px] border border-[#ddd] text-[#37003C99] rounded-md bg-[#F5F2F580] font-medium 
                      text-[13px] px-3 py-1 leading-tight tracking-tight"
                  >
                    <span>{hometeamGoal}</span>
                    {
                      isCheckStatusLive(status) ? <span
                        style={{
                          display: "inline-block",
                          margin: "0 6px",
                          width: "10px",
                          height: "10px",
                          borderRadius: "50%",
                          backgroundColor: "#37c570",
                          verticalAlign: "middle",
                          boxShadow: "0 0 6px 2px rgba(0, 128, 0, 0.6)",
                        }}
                      ></span>
                        : ":"
                    }
                    <span>{awayteamGoal}</span>

                  </div>
              }

            </>
          )}
        </>
      )}
      <TeamBlock
        teamType="away"
        short={short}
        logo={awayteam_logo}
        teamId={id}
        currentFixtureId={id}
        selectedPickTeam={selectedPickTeam}
        onClick={handleClickTeamSide}
        componentType={componentType}
        currentMatchWeek={currentMatchWeek}
        pickStatus={pickStatus}
        pickDetailMatchWeek={pickDetailMatchWeek}
        setFisttime={setFisttime}
        isTimeEnd={isTimeEnd}
        status={status}
      />
    </div>
  );
};

// Main Component
function PickDetailFixtures({
  pickId,
  setPickDetails,
  currentMatchWeek,
  seasonId,
  allMatchWeek,
  pickStatus,
  potId,
  isTimeEnd,
  isPickFixturesLoading,
  isDifficultyRating,
  setIsDifficultyRating,
  otherPlayersPrediction,
  allOtherPlayerData,
  configuredLeagueId,
  btnName
}) {
  const { showToast, showErrorToast } = useToastMessage();

  const fixture = useSelector((state) => state.pickDetail.fixtures);

  const socketRef = useWebSocket("/ws/livefixture/");
  const dispatch = useDispatch();
  const [defaultPickTeam, setDefaultPickTeam] = useState({
    teamType: "",
    teamId: "",
  });
  const [selectedPickTeam, setSelectedPickTeam] = useState({
    teamType: "",
    teamId: "",
  });
  let [fisttime, setFisttime] = useState(true);
  const [selected, setSelected] = useState("left");

  const pickDetailMatchWeek = useSelector(
    (state) => state.roundToJoin.pickDetailMatchWeek
  );

  const [matchWeek, setMatchWeek] = useState(Number(currentMatchWeek) || 1);

  const minWeek = allMatchWeek?.length
    ? Math.min(...allMatchWeek.map((m) => m.matchweek_number))
    : 1;
  const maxWeek = allMatchWeek?.length
    ? Math.max(...allMatchWeek.map((m) => m.matchweek_number))
    : 1;

  const handleClickTeamSide = (fixtureId, teamType) => {
    setSelectedPickTeam({ teamType, teamId: fixtureId });
  };

  async function updatePick() {
    try {
      const rawToken = localStorage.getItem("access_token");
      const token = rawToken ? JSON.parse(rawToken) : null;
      if (!token) {
        console.warn("Access token is missing");
        return;
      }
      const apiUrl = defaultPickTeam.teamId
        ? `${baseURL}/pot/selectpicks/${pickId}`
        : `${baseURL}/pot/selectpicks`;
      console.log(apiUrl)
      const axiosMethod = defaultPickTeam.teamId ? axios.put : axios.post;
      let prediction = fixture
        .find((ele) => ele.id === selectedPickTeam.teamId)
        .short.find((ele) => ele.team_type === selectedPickTeam.teamType);

      if (!prediction) {
        setFisttime(true);
        // setSelectedPickTeam({
        //   teamType: defaultPickTeam.teamType,
        //   teamId: defaultPickTeam.teamId,
        // });
        showErrorToast('Selected Team Name not found')
      } else {
        const res = await axiosMethod(
          apiUrl,
          {
            pick: pickId,
            prediction: prediction.name,
            team: selectedPickTeam.teamType,
            pot: potId,
            fixture: selectedPickTeam.teamId,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (res.data?.data?.code === 200) {
          setSelectedPickTeam({
            teamType: selectedPickTeam.teamType,
            teamId: selectedPickTeam.teamId,
          });
          setDefaultPickTeam({
            teamType: selectedPickTeam.teamType,
            teamId: selectedPickTeam.teamId,
          });
          setPickDetails((prev) => {
            return {
              ...prev,
              fixture: prev.fixture.map((ele) => {
                return {
                  ...ele,
                  short: ele.short.map((item) => {
                    if (item.name === res.data?.data.predictions) {
                      return {
                        ...item,
                        name: res.data?.data.predictions,
                        code: res.data?.data.short_name,
                        not_available: false,
                        predicted: true,
                      };
                    } else {
                      return {
                        ...item,
                        predicted: false,
                      };
                    }
                  }),
                };
              }),
            };
          });
          setFisttime(true);
        } else {
          setFisttime(true);
          setSelectedPickTeam({
            teamType: defaultPickTeam.teamType,
            teamId: defaultPickTeam.teamId,
          });
          showErrorToast('Selected Not selected')
        }
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        refreshTokenV2(dispatch);
      }
      if (error?.response?.status === 400) {
        setFisttime(true);
        setSelectedPickTeam({
          teamType: defaultPickTeam.teamType,
          teamId: defaultPickTeam.teamId,
        });
        showErrorToast('Failed to update pick')
      }
      console.error("Update Pick Error:", error);
    }
  }

  const handleConfirm = () => updatePick();
  const handleCancel = () => {
    setFisttime(true);
    setSelectedPickTeam({
      teamType: defaultPickTeam.teamType,
      teamId: defaultPickTeam.teamId,
    });
  };

  useEffect(() => {
    if (matchWeek) {
      dispatch(updatePickMAtchWeek(matchWeek));
    }
  }, [matchWeek]);

  useEffect(() => {
    fixture?.forEach((ele) => {
      ele.short.find((item) => {
        let teamType = item.team_type;
        if (item.predicted) {
          setSelectedPickTeam({ teamType: teamType, teamId: ele.id });
          setDefaultPickTeam({ teamType: teamType, teamId: ele.id });
        }
      });
    });
  }, [fixture]);

  const sendTestMessage = () => {
    if (WebSocket.OPEN) {
      console.log("WebSocket is open");
    } else {
      console.log("WebSocket is not open");
    }
  };

  useEffect(() => {
    sendTestMessage()
  }, [])

  return (
    <div className="w-full relative lg:w-1/3 xl:h-[700px] md:h-[600px] bg-white flex flex-col rounded-[12px] border border-gray-200 h-screen">
      {/* Popup */}
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />
      {selectedPickTeam.teamId && !fisttime && (
        <PickFixtureConfirmPopup
          message={"Do you want to update the team?"}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      )}

      {/* Header */}
      {
        isDifficultyRating === 'left' ? <div className="p-4 border-b-4 border-[#111111] text-center rounded-t-lg">
          <h2 className="text-lg font-bold text-[#181818] tracking-wide font-archivo">
            My Picks
          </h2>
          <p className="text-sm text-[#505050] font-archivo mt-1">
            Choose your pick for the match week
          </p>
        </div> : <div className="p-3 border-b-4 flex justify-between border-[#111111] rounded-t-lg">
          <div>
            <h2 className={`font-bold text-[#181818] font-archivo whitespace-nowrap ${
              (window.innerWidth >= 820 && window.innerWidth <= 1180) || (window.innerWidth === 1366 && window.innerHeight === 768)
                ? "text-[16px]"
                : "text-base md:text-xl"
            }`}>
              Picks Difficulty Rating
            </h2>
            <p className={`text-[#505050] font-archivo mt-1 whitespace-nowrap ${
              (window.innerWidth >= 820 && window.innerWidth <= 1180) || (window.innerWidth === 1366 && window.innerHeight === 768)
                ? "text-[12px]"
                : "text-xs md:text-base"
            }`}>
              Use this key to validate the difficulty
            </p>
          </div>
          <div className="flex mt-1 -mx-1 md:px-1 gap-2">
            <h6 className={`-mx-1 font-bold text-[#00000080] font-archivo whitespace-nowrap ${
              (window.innerWidth >= 820 && window.innerWidth <= 1180) || (window.innerWidth === 1366 && window.innerHeight === 768)
                ? "text-[10px]"
                : "text-xs md:text-base"
            }`}>
              PDR Key
            </h6>
            <div className="flex flex-col gap-1 md:gap-2">
              <div className="flex md:gap-0.5">
                {COLOR_RATING.map((ele) => (
                  <div key={ele.lable}>
                    <p
                      style={{ background: ele.colorCode, color: ele.textColor }}
                      className={`px-1 md:px-2 py-1 md:py-2 h-4 md:h-5 flex items-center font-archivo ${
                        (window.innerWidth >= 820 && window.innerWidth <= 1180) || (window.innerWidth === 1366 && window.innerHeight === 768)
                          ? "text-[10px]"
                          : "text-[10px] md:text-lg"
                      }`}
                    >
                      {ele.lable}
                    </p>
                  </div>
                ))}
              </div>

              {/* Easy / Hard row */}
              <div className="flex justify-between">
                <p className={`font-medium text-[#00000080] ${
                  (window.innerWidth >= 820 && window.innerWidth <= 1180) || (window.innerWidth === 1366 && window.innerHeight === 768)
                    ? "text-[8px]"
                    : "text-[8px] md:text-xs"
                }`}>Easy</p>
                <p className={`font-medium text-[#00000080] ${
                  (window.innerWidth >= 820 && window.innerWidth <= 1180) || (window.innerWidth === 1366 && window.innerHeight === 768)
                    ? "text-[8px]"
                    : "text-[8px] md:text-xs"
                }`}>Hard</p>
              </div>
            </div>
          </div>
        </div>
      }

      {isDifficultyRating === 'left' ? (
        <>
          {isPickFixturesLoading ? (
            <CircularLoader />
          ) : (
            <>
              <div className="flex items-center justify-between bg-[#009fae] text-white p-4">
                <img
                  src={arrowBack}
                  className={`h-5 w-5 cursor-pointer transition-opacity 
            ${matchWeek <= minWeek
                      ? "opacity-40 pointer-events-none"
                      : "opacity-100"
                    }
          `}
                  alt="Previous"
                  onClick={() => {
                    if (matchWeek > minWeek) setMatchWeek((prev) => prev - 1);
                  }}
                />
                <span className="lg:text-lg font-semibold font-archivo">
                  Match Week {pickDetailMatchWeek}
                </span>
                <img
                  src={arrowBack}
                  className={`h-5 w-5 rotate-180 cursor-pointer transition-opacity 
            ${matchWeek >= maxWeek
                      ? "opacity-40 pointer-events-none"
                      : "opacity-100"
                    }
          `}
                  alt="Next"
                  onClick={() => {
                    if (matchWeek < maxWeek) setMatchWeek((prev) => prev + 1);
                  }}
                />
              </div>

              {/* Fixture List */}

              <div className={`p-4 ${btnName !== "viewDetails" ? " bg-white" : ""}  flex-grow overflow-y-auto`}>
                {fixture?.length > 0 ? (
                  fixture.map((fix, index) => {
                    return (
                      <TeamSection
                        key={fix.id || index}
                        {...fix}
                        index={index}
                        awayteamGoal={fix.awayteam_goal}
                        hometeamGoal={fix.hometeam_goal}
                        result={fix.result}
                        currentMatchWeek={currentMatchWeek}
                        fixtureLeangth={fixture?.length}
                        selectedPickTeam={selectedPickTeam}
                        pickStatus={pickStatus}
                        pickDetailMatchWeek={pickDetailMatchWeek}
                        handleClickTeamSide={handleClickTeamSide}
                        setFisttime={setFisttime}
                        componentType="choose pick"
                        isTimeEnd={isTimeEnd}
                      />
                    );
                  })
                ) : (
                  <div className="text-center text-gray-400 pt-8">
                    No fixtures available
                  </div>
                )}
              </div>
              {btnName !== "viewDetails" && <div className="relative">
                <img
                  src={PitchImage}
                  alt="Pitch"
                  className="w-full object-cover rounded-b-lg"
                />
                <GlassSlider active={isDifficultyRating} configuredLeagueId={configuredLeagueId} setSelected={setIsDifficultyRating} />
              </div>}
            </>
          )}
        </>
      ) : (
        <>
          <DifficultyRating currentMatchWeek={currentMatchWeek} seasonId={seasonId}
            active={isDifficultyRating} allOtherPlayerData={allOtherPlayerData}
            pickId={pickId} setSelected={setIsDifficultyRating}
            otherPlayersPrediction={otherPlayersPrediction} />
          <div className="absolute bottom-0  w-full z-20 bg-white">
            <img src={PitchImage} alt="Pitch" className="w-full h-full object-cover" />
            <GlassSlider active={isDifficultyRating} setSelected={setIsDifficultyRating} configuredLeagueId={configuredLeagueId} />
          </div>
        </>
      )}

      {/* Matchweek Navigation */}
    </div>
  );
}

export default PickDetailFixtures;